import { render, staticRenderFns } from "./LinkedBusinesses.vue?vue&type=template&id=a8305808&"
import script from "./LinkedBusinesses.vue?vue&type=script&lang=js&"
export * from "./LinkedBusinesses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports